export function setSubsidiaries(state, subsidiaries) {
    state.subsidiaries = subsidiaries
}

export function setUserSubsidiary(state, subsidiary) {
    state.user_subsidiary = subsidiary
}

export function cleanSubsidiariesInfo(state) {
    state.user_subsidiary = null
    state.subsidiaries = null
}

export function setProductsSubsidiary(state, products) {
    state.products_by_subsidiary = products
}

export function setRentOperation(state, operation) {
    state.rent_operations.push(operation)
}

export function cleanRentOperation(state, operation_id) {
    let new_rent_operations = state.rent_operations.filter(f => f.operation_id !== operation_id)
    state.rent_operations = new_rent_operations
}

export function cleanRentOperations(state) {
    state.rent_operations = []
}
